import React, { useState } from "react";
import { createPortal } from "react-dom";
import InsertFRMS from "./InsertFRMS";
import ModifyFRMS from "./ModifyFRMS";
import '../All CSS/FormSetting.css';

function FRMSSettings({ purchaseOrderHeaderTarget = null }) {
  const [activeTab, setActiveTab] = useState("INSERT");

  return (
    <>
      {purchaseOrderHeaderTarget && createPortal(
        <div className="frms-settings-tabs">
          <div className="frms-settings-tabs-bar">
            <button
              type="button"
              className={`frms-settings-tab-button mode-insert ${activeTab === "INSERT" ? "active" : ""}`}
              onClick={() => setActiveTab("INSERT")}
            >
              Insert
            </button>

            <button
              type="button"
              className={`frms-settings-tab-button mode-modify ${activeTab === "MODIFY" ? "active" : ""}`}
              onClick={() => setActiveTab("MODIFY")}
            >
              Modify
            </button>
          </div>
        </div>,
        purchaseOrderHeaderTarget,
      )}

      {activeTab === "INSERT" ? (
        <InsertFRMS />
      ) : (
        <ModifyFRMS />
      )}
    </>
  );
}

export default FRMSSettings;
